<div role="status" class="py-16">
	<div aria-hidden="true" class="pb-16 animate-pulse sm:flex sm:items-center">
		<div class="w-full">
			<div class="h-6 bg-gray-300 rounded-full max-w-[480px]"></div>
		</div>
	</div>
	<div aria-hidden="true" class="grid animate-pulse md:grid-cols-3 md:gap-8">
		<div class="w-full">
			<div class="h-3.5 bg-gray-200 rounded-full w-48 mb-4"></div>
			<div class="h-3.5 bg-gray-200 rounded-full w-56 mb-4"></div>
			<div class="h-3.5 bg-gray-200 rounded-full w-48 mb-4"></div>
		</div>
		<div class="w-full">
			<div class="h-3.5 bg-gray-200 rounded-full w-48 mb-4"></div>
			<div class="h-3.5 bg-gray-200 rounded-full w-56 mb-4"></div>
			<div class="h-3.5 bg-gray-200 rounded-full w-48 mb-4"></div>
		</div>
		<div class="w-full">
			<div class="h-3.5 bg-gray-200 rounded-full w-48 mb-4"></div>
			<div class="h-3.5 bg-gray-200 rounded-full w-56 mb-4"></div>
			<div class="h-3.5 bg-gray-200 rounded-full w-48 mb-4"></div>
		</div>
	</div>
	<span class="sr-only">Loading...</span>
</div>
